import styled from '@emotion/styled';
import { Menu as AMenu, MenuProps } from 'antd';

const { SubMenu: ASubMenu } = AMenu;

export interface IMenuParams extends Omit<MenuProps, 'theme'> {}

export const Menu = styled(AMenu)`
  border: 0;
  &.ant-menu:not(.ant-menu-horizontal) {
    /* SubMenu 기본 스타일 */
    padding-top: 10px;
    .ant-menu-submenu .ant-menu-submenu-arrow {
      border: 0 !important;
      display: none;
    }
    .ant-menu-submenu .ant-menu-submenu-title {
      font-size: 15px;
      margin: unset;
      padding: 0 20px !important;
      width: 100%;
    }
    .ant-menu-submenu .ant-menu-submenu-title > span {
      margin-left: 6px;
      color: ${({ theme }) => theme.gray11};
    }
    /* SubMenu-title:hover, selected */
    .ant-menu-submenu.ant-menu-submenu-active,
    .ant-menu-submenu.ant-menu-submenu-selected {
      .ant-menu-submenu-title > span {
        font-weight: bold;
        color: ${({ theme }) => theme.main2};
      }
      svg path {
        stroke: ${({ theme }) => theme.main2};
      }
    }

    /* Item 기본 스타일 */
    .ant-menu-item {
      height: 34px;
      line-height: 34px;
      width: 100%;
    }
    .ant-menu-item.ant-menu-item-only-child {
      background: ${({ theme }) => theme.gray1};
      padding-left: 42px !important;
      font-size: 14px;
      margin: 0;
      a {
        display: block;
        height: 100%;
        color: ${({ theme }) => theme.gray9};
        font-weight: normal;
      }
    }

    /* Item-title: hover, selected */
    .ant-menu-item.ant-menu-item-active,
    .ant-menu-item.ant-menu-item-selected {
      background: ${({ theme }) => theme.main1};
      a {
        color: ${({ theme }) => theme.main2};
        font-weight: bold;
      }
      ::after {
        transform: scaleY(0);
      }
    }
  }

  /* Menu Collapsed */
  &.ant-menu.ant-menu-inline-collapsed {
    width: 57px;
    .ant-menu-submenu .ant-menu-submenu-title {
      text-align: center;
      padding: 0 !important;
    }
    .ant-menu-submenu .ant-menu-submenu-title > span {
      display: none;
    }
    /* SubMenu-title:hover, selected */
    .ant-menu-submenu.ant-menu-submenu-active,
    .ant-menu-submenu.ant-menu-submenu-selected {
      .ant-menu-submenu-title {
        background: ${({ theme }) => theme.main1};
      }
    }
  }
`;

export const SubMenu = styled(ASubMenu)``;
export const MenuItem = AMenu.Item;
